import React from 'react';
export function CompanyInfoForm(_ref) {
  let {} = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null);
}